import { DefaultRequest } from 'scripts/api';

Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.FieldColumn = function() {

    this._listeners = {};

    this.addEventListener = function(name, handler) {
        this._listeners[name] = handler;
    };

    this.createCheckbox = function() {
        this.checkbox = document.createElement("input");
        this.checkbox.setAttribute("type", "checkbox");
        this.checkbox.setAttribute("class", "checkboxItem");

        if(this._field) {
            this.checkbox.setAttribute("id", `check_${this._field.field ? this._field.field.id : this._field.id}`);
        }

        this.checkbox.addEventListener("change", function() {
            var eventName = "focused";

            if(this.checkbox.checked) {
                $(this.orderItem).on("keyup blur", this.inputListener.bind(this));
            } else {
                this.orderItem.value = "";
                eventName = "ordered";
            }

            var handler = this._listeners[eventName];
            if(handler) {
                handler(this);
            }

        }.bind(this));
    };

    this.createDragItem = function() {
        this.dragItem = document.createElement("div");
        this.dragItem.setAttribute("class", "dragItem");
    };

    this.createItem = function(field) {
        this.item = document.createElement("li");
        this.item.setAttribute("class", "popupCustomizeColumnsItems");
        this.item.setAttribute("fieldId", field.id);
        this.item.setAttribute("id", "GridLayout_" + field.name );

        this.item.appendChild(this.dragItem);
        this.item.appendChild(this.checkbox);
        this.item.appendChild( this.columnItem );
        this.item.appendChild( this.orderItem );

        this.item.fieldColumn = this;

        return this.item;
    };

    this.isNumber = function() {
        return Number(this.orderItem.value) && Number(this.orderItem.value) > 0;
    };

    this.inputListener = function(e) {
        var key = e.which || e.keyCode;
        var handler = this._listeners["ordered"];
        if (((key && key === 13) || !key) && handler) {
            e.target.parentElement.style.backgroundColor = '#ddd';
            handler(this);
            $(e.target.parentElement).animate({backgroundColor: '#fff'}, 1000, function() {
                e.target.parentElement.style.backgroundColor = '';
            });
        } else if(!this.isNumber()) {
            this.orderItem.value = "";
        }
    }

    this.createOrderItem = function() {
        this.orderItem = document.createElement("input");
        this.orderItem.setAttribute("type", "text");
        this.orderItem.setAttribute("class", "orderItem");

        $(this.orderItem).on("keyup blur", this.inputListener.bind(this));
    };

    this.createColumnItem = function(field) {
        this.columnItem = document.createElement("label");
        this.columnItem.setAttribute("class", "columnItem");

        if(field && field.id) {
            this.columnItem.htmlFor = `check_${field.id}`;
        };

        this.columnItem.innerHTML = Monet.I18n.getResourcesByKey(field.label);
    };

    this.getLabel = function() {
        var label = (this._field.field)? this._field.field.label : this._field.label;
        return Monet.I18n.getResourcesByKey(label);
    };

    this.setOrder = function(order) {
        this.orderItem.value = order + 1;
    };

    this.getOrder = function() {
        return this.orderItem.value;
    };

    this.check = function() {
        this.checkbox.checked = true;
    };

    this.unCheck = function() {
        this.orderItem.value = "";
        this.checkbox.checked = false;
    };

    this.getId = function() {
        if(this._field.field) {
            return this._field.field.id;
        } else {
            return this._field.id;
        }
    };

    this.render = function(field) {
        this._field = field;
        this.createDragItem();
        this.createCheckbox();
        if(field.field) {
            field = field.field;
            this.checkbox.setAttribute("checked", true);
        }
        this.createColumnItem(field);
        this.createOrderItem();

        if( this._field.columnOrder > -1 ) {
            this.orderItem.value = this._field.columnOrder + 1;
        }

        return this.createItem(field);
    };

};

Monet.Grid.ActionsModules.CustomizeColumns = function () {

    this.layoutNameSpace = null;
    this.entity = null;
    this.selector = null;
    this.element = null;
    this.screenName = null;
    this.action = "index";
    this.data = null;
    this.customNamespace = null;
    this.customSaveAction = null;
    this.fieldList = [];
    this.hiddenFields = [];

    this.frozenFieldColumns = [];
    this.notFrozenFieldColumns = [];
    this.notFrozenDeselectedFieldColumns = [];

    this.setHiddenFields = function (hiddenFields) {
      this.hiddenFields = hiddenFields;
    };

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setActionToGridLayout = function (action) {
        this.action = action;
    };

    this.setSelector = function (selector) {
        this.selector = selector;
    };

    this.setElement = function (element) {
        this.element = element;
    };

    this.setLayoutNameSpace = function (layout) {
        this.layoutNameSpace = layout;
    };

    this.setCallBacks = function (callbacks) {
        this.callbacks = callbacks;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    this.setData = function(data) {
        this.data = data;
    };

    this.setCustomSaveAction = function(customSaveAction) {
        this.customSaveAction = customSaveAction;
    };

    this.setCustomNamespace = function(customNamespace) {
        this.customNamespace = customNamespace;
    };

    this.setCustomFieldList = function(fieldList) {
        this.fieldList = fieldList;
    }

    var setContentEmptyFrozenColumns = function () {

        var key = "Greenmile.CustomizeColumns.label.columnsFrozen";
        var div = document.createElement('div');
        div.setAttribute("class", "frozenEmptyList");

        div.id = "frozenEmptyList";
        div.textContent = Monet.I18n.getResourcesByKey(key);

        return div;
    };

    this.checkElementAndAppendChild = function (element, child) {
        if (element !== null) {
            element.appendChild(child);
        }
    };

    this.renderFieldItem = function() {
        return new Monet.Grid.ActionsModules.FieldColumn();
    };

    this.notIncluded = function(item) {
        return this.gridList.filter(function(column){
            return column.field.id === item.id;
        }).length === 0;
    };

    this.filterField = function(field) {
        return field.name !== "id" && !Monet.Grid.blackList(field.name) && this.notIncluded(field) && !this.hiddenFields.includes(field.name);
    }.bind(this);

    this.cleanArea = function() {
        this.frozen.innerHTML = "";
        this.notFrozen.innerHTML = "";
        this.notFrozenDeselected.innerHTML = "";

        this.frozenFieldColumns = [];
        this.notFrozenFieldColumns = [];
        this.notFrozenDeselectedFieldColumns = [];
    };

    this.filterFrozen = function(item){
        return item.isFrozen;
    };

    this.filterNotFrozen = function(item){
        return !item.isFrozen;
    };

    this.removeFrozedFieldColumn = function(fieldColumn) {
        try {
            if(fieldColumn.item.parentElement.className.indexOf(this.frozen.className) !== -1 ) {
                $(this.orderItem).off("keyup blur");
                this.frozen.removeChild( fieldColumn.item );
                this.removeFieldColumn(fieldColumn, this.frozenFieldColumns);
            }
        } catch(e) {
            console.log(`Error while trying to remove item: "${e.message}"`);
        }
    };

    this.removeNotFrozedFieldColumn = function(fieldColumn) {
        try {
            $(this.orderItem).off("keyup blur");
            this.notFrozen.removeChild( fieldColumn.item );
            this.removeFieldColumn(fieldColumn, this.notFrozenFieldColumns);
        } catch(e) {
            console.log(`Error while trying to remove item: "${e.message}"`);
        }
    };

    this.removeNotFrozenDeselectedFieldColumn = function(fieldColumn) {
        try {
            $(this.orderItem).off("keyup blur");
            this.notFrozenDeselected.removeChild( fieldColumn.item );
            this.removeFieldColumn(fieldColumn, this.notFrozenDeselectedFieldColumns);
        } catch(e) {
            console.log(`Error while trying to remove item: "${e.message}"`);
        }
    };

    var findFirstElement = function(newOrder, fieldColumn, element, collection) {
        var referenceFieldColumns = collection.filter( function(field){
            return field.getOrder() === newOrder;
        } );

        var referenceFieldColumn = referenceFieldColumns[0];

        if (referenceFieldColumns.length > 1) {
            referenceFieldColumns.forEach(function(field) {
                if (field !== fieldColumn) {
                    referenceFieldColumn = field;
                    return;
                }
            });
        }

        if(!referenceFieldColumn) {
            var firstElement = element.querySelector("li");
            if(firstElement) {
                referenceFieldColumn = firstElement.fieldColumn;
            } else {
                referenceFieldColumn = fieldColumn;
            }
        }
        return referenceFieldColumn;
    }.bind(this);

    this.moveToNotFrozenDeselected = function(fieldColumn) {
        var exist = this.notFrozenDeselectedFieldColumns.filter(function(field){
            return field.getId() === fieldColumn.getId();
        }).length;
        if(!exist) {
            this.removeFrozedFieldColumn(fieldColumn);
            this.removeNotFrozedFieldColumn(fieldColumn);

            this.notFrozenDeselected.appendChild( fieldColumn.item );
            this.notFrozenDeselectedFieldColumns.push(fieldColumn);
            this.reOrderFrozen();
            this.notFrozenDeselectEspecialBehavior();
        }
    };

    this.moveToFrozen = function(fieldColumn) {
        var newOrder = fieldColumn.getOrder();

        var exist = this.frozenFieldColumns.filter(function(field){
            return field.getId() === fieldColumn.getId();
        }).length;

        var referenceFieldColumn = findFirstElement(newOrder, fieldColumn, this.frozen, this.frozenFieldColumns);

        if(exist) {
            this.removeFrozedFieldColumn(fieldColumn);

            this.frozen.insertBefore( fieldColumn.item, referenceFieldColumn.item );
        } else {
            this.removeNotFrozedFieldColumn(fieldColumn);
            this.removeNotFrozenDeselectedFieldColumn(fieldColumn);

            this.frozen.insertBefore( fieldColumn.item, referenceFieldColumn.item );
            this.frozenFieldColumns.push(fieldColumn);
        }

        this.reOrderFrozen();
    };

    this.moveToNotFrozen = function(fieldColumn) {

        var oldOrder = Array.prototype.indexOf.call(this.notFrozen.childNodes, fieldColumn.item) + 1;
        var newOrder = fieldColumn.getOrder();
        var orderLength = this.frozenFieldColumns.length + this.notFrozenFieldColumns.length;
        var referenceFieldColumn;

        var exist = this.notFrozenFieldColumns.filter(function(field){
            return field.getId() === fieldColumn.getId();
        }).length;

        if(exist) {
            referenceFieldColumn = findFirstElement(newOrder, fieldColumn, this.notFrozen, this.notFrozenFieldColumns);
            if (oldOrder < parseInt(newOrder)) {
                this.notFrozen.insertBefore(fieldColumn.item, referenceFieldColumn.item.nextSibling);
            }
            else {
                this.notFrozen.insertBefore(fieldColumn.item, referenceFieldColumn.item);
            }
            this.removeFieldColumn(fieldColumn, this.notFrozenFieldColumns);
        } else {

            this.removeFrozedFieldColumn(fieldColumn);
            this.removeNotFrozenDeselectedFieldColumn(fieldColumn);

            if(Number(newOrder) > orderLength ) {
                this.notFrozen.appendChild( fieldColumn.item );
            } else {
                referenceFieldColumn = findFirstElement(newOrder, fieldColumn, this.notFrozen, this.notFrozenFieldColumns);
                this.notFrozen.insertBefore( fieldColumn.item, referenceFieldColumn.item );
            }

        }

        this.notFrozenFieldColumns.push(fieldColumn);

        this.reOrderFrozen();
        this.notFrozenEspecialBehavior();
    };

    var verifyFrozenEmpty = function() {
        if(this.frozen.childNodes.length === 0) {
            this.frozen.appendChild(setContentEmptyFrozenColumns());
        }
    }.bind(this);

    this.remakeRadius = function() {
        const selectedLength = this.notFrozen.childNodes.length;
        const deselectedLength = this.notFrozenDeselected.childNodes.length;
        const deselectedList = this.notFrozenDeselected;
        const selectedList = this.notFrozen;

        if (selectedLength === 0 && deselectedLength === 1) {
            deselectedList.classList.remove("br-t4");
            deselectedList.classList.remove("notFrozenDeselected");
            deselectedList.classList.add("br-4");
        } else if (deselectedLength === 0 && selectedLength === 1) {
            selectedList.classList.remove("br-b4");
            selectedList.classList.remove("notFrozen");
            selectedList.classList.add("br-4");
        } else if (deselectedLength === 1 && selectedLength === 1) {
            selectedList.classList.remove("br-4");
            selectedList.classList.add("br-t4");
        } else if (selectedLength === 0) {
            deselectedList.classList.add("br-t4");
        }
    };

    this.notFrozenEspecialBehavior = function() {
        const selectedLength = this.notFrozen.childNodes.length;
        const deselectedLength = this.notFrozenDeselected.childNodes.length;
        const selectedList = this.notFrozen;
        const deselectedList = this.notFrozenDeselected;

        if (deselectedLength === 0) {
            selectedList.classList.add("bb");
            selectedList.classList.add("br-b4");
            selectedList.classList.remove("bb-0");
        } else if (selectedLength !== 0) {
            deselectedList.classList.remove("br-t4");
        }
    };

    this.notFrozenDeselectEspecialBehavior = function() {
        const selectedLength = this.notFrozen.childNodes.length;
        const deselectedLength = this.notFrozenDeselected.childNodes.length;
        const selectedList = this.notFrozen;
        const deselectedList = this.notFrozenDeselected;

        if (deselectedLength === 1 && selectedLength === 0) {
            deselectedList.classList.remove("notFrozenDeselected");
            deselectedList.classList.add("br-4");
        } else if (deselectedLength !== 0) {
            deselectedList.classList.add("notFrozenDeselected");
            deselectedList.classList.remove("br-4");
            selectedList.classList.remove("bb", "br-b4");
            selectedList.classList.add("bb-0");
        } else if (selectedLength === 0) {
            deselectedList.classList.add("br-t4");
        }
    };

    this.InitalVerificationOfEmptyLists = function() {
        const deselectedListLenght = this.notFrozenDeselected.childNodes.length;
        const selectedListLenght = this.notFrozen.childNodes.length;
        const selectedList = this.notFrozen;
        const deselectedList = this.notFrozenDeselected;

        if (selectedListLenght === 0) {
            deselectedList.classList.add("br-t4");
        } else if (selectedListLenght !== 0 && deselectedListLenght !== 0) {
            selectedList.classList.add("bb-0");
            deselectedList.classList.remove("br-t4");
        } else if (deselectedListLenght === 0) {
            selectedList.classList.remove("bb-0");
        }
    };

    var moveToPosition = function(fieldColumn){

        var newOrder = fieldColumn.getOrder();

        if(newOrder === "") {
            this.moveToNotFrozenDeselected(fieldColumn);
            fieldColumn.unCheck();
            this.reOrderNotFrozenDeselected();
        } else {
            var frozenFieldColumnsLength = this.frozenFieldColumns.length;
            if(newOrder < frozenFieldColumnsLength && newOrder > 0) {
                this.moveToFrozen(fieldColumn);
            }

            if(newOrder >= frozenFieldColumnsLength) {
                this.moveToNotFrozen(fieldColumn);
            }
        }

        verifyFrozenEmpty();
        this.remakeRadius();
    }.bind(this);

    var suggestOrder = function(fieldColumn) {
        var order = this.frozenFieldColumns.length + this.notFrozenFieldColumns.length;
        fieldColumn.setOrder(order);

        moveToPosition( fieldColumn );

    }.bind(this);

    var createAndPopulateField = function(field, element, collection) {
        var fieldColumn = this.renderFieldItem();

        fieldColumn.addEventListener("ordered", moveToPosition);
        fieldColumn.addEventListener("focused", suggestOrder);

        if(typeof field.columnOrder === "undefined") {
            field.columnOrder = -1;
        }

        element.appendChild( fieldColumn.render(field) );
        collection.push( fieldColumn );
    }.bind(this);

    this.addField = function(field) {
        createAndPopulateField(field, this.notFrozenDeselected, this.notFrozenDeselectedFieldColumns);
    }.bind(this);

    this.populateSavedGridColumns = function() {
        this.cleanArea();
        this.gridList = this.retrieveAvailableColumnsFromLayout().filter((column) => !Monet.Grid.blackList(column.field.name));

        this.gridList
            .filter(this.filterFrozen)
            .forEach(function(field) {
                createAndPopulateField(field, this.frozen, this.frozenFieldColumns);
            }, this);

        if(!this.frozenFieldColumns.length) {
            this.frozen.appendChild( setContentEmptyFrozenColumns() );
        }

        this.gridList
            .filter(this.filterNotFrozen)
            .forEach(function(field) {
                createAndPopulateField(field, this.notFrozen, this.notFrozenFieldColumns);
            }, this);

    };

    this.renderList = function() {
        this.togglePopUp();

        const fields = (this.fieldList.length)
                            ? Object.values({ ...this.fieldList })
                            : Object.values({ ...App.Forms[this.entity].fields });

        const successCallback = (fields) => {
            this.populateSavedGridColumns();
            this.setData(fields);
            fields.filter(this.filterField).forEach(this.addField);
            this.reOrderFrozen();
            this.reOrderNotFrozenDeselected();
            this.InitalVerificationOfEmptyLists();
        };

        if (fields && fields.length) {
            successCallback(fields);
        } else {
            this.getFieldList(successCallback);
        }
    };

    this.getFieldList = function (callback) {
      if (!this.data) {
          const request = new DefaultRequest({
              url: "form/" + this.entity + "/Fields",
              success: callback
          });
          request.send();
      }
    };

    this.createBtn = function () {

        const buttons = document.createElement("div");
        buttons.setAttribute("class", "MonetUIGridActionsButton " + this.entity);

        const gridCustomColumns = document.createElement("div");
        const translatedTitle = Monet.I18n.getResourcesByKey('Monet.CustomizeColumns.label.title');

        gridCustomColumns.setAttribute("class", "MonetUIGridActionsCustomColumns");
        gridCustomColumns.setAttribute("title", translatedTitle);
        gridCustomColumns.addEventListener("click", this.renderList.bind(this) );

        buttons.appendChild(gridCustomColumns);

        this.checkElementAndAppendChild(this.element, buttons);

    };

    this.reOrderNotFrozen = function() {
        var frozenLength = this.frozenFieldColumns.length;
        var list = this.notFrozen.querySelectorAll("li");

        var item;
        for(item = 0; item < list.length; item++) {
            var field = list[item];
            if(field) {
                field.fieldColumn.setOrder(item + frozenLength);
                field.fieldColumn.check();
            }
        }

        this.notFrozenEspecialBehavior();
    };

    this.reOrderNotFrozenDeselected = function() {
        var deselectedList = $(this.notFrozenDeselected.querySelectorAll('li'));
        var orderedList = deselectedList.sort(function(a, b){
            if (a.fieldColumn.getLabel() > b.fieldColumn.getLabel()) {
                return 1;
            } else if (a.fieldColumn.getLabel() < b.fieldColumn.getLabel())  {
                return -1;
            }
            return 0;
        });

        var fragment = document.createDocumentFragment();
        for(var item = 0; item < orderedList.length; item++) {
            fragment.appendChild(orderedList[item]);
        }

        this.notFrozenDeselected.appendChild(fragment);
        this.remakeRadius();
    };

    this.reOrderFrozen = function() {
        var list = this.frozen.querySelectorAll("li");
        for(var item = 0; item < list.length; item++) {
            var field = list[item];
            if(field) {
                field.fieldColumn.setOrder(item);
                field.fieldColumn.check();
            }
        }
        this.reOrderNotFrozen();
        this.remakeRadius();
    };

    this.removeFieldColumn = function(fieldColumn, collection) {
        var index = -1;

        collection.forEach(function(field, indexFounded){
            if( field.getId() ===  fieldColumn.getId()) {
                index = indexFounded;
            }
        });

        if(index > -1) {
            collection.splice(index, 1);
        }
    };

    var createNotFrozen = function() {
        this.notFrozen = document.createElement("div");
        this.notFrozen.setAttribute("class", "notFrozen connectedSortable ui-sortable");
        $(this.notFrozen).sortable({
            connectWith: ".connectedSortable",
            update: function() {
                this.reOrderNotFrozen();
            }.bind(this),
            remove: function(event, ui) {
                this.removeFieldColumn(ui.item[0]?.fieldColumn, this.notFrozenFieldColumns);
                this.reOrderNotFrozen();
            }.bind(this),
            receive: function (event, ui) {
                const fieldColumn = ui.item[0]?.fieldColumn;

                fieldColumn.check();
                this.notFrozenFieldColumns.push( fieldColumn );
                this.reOrderNotFrozen();
            }.bind(this)
        });
        return this.notFrozen;
    }.bind(this);

    var createFrozen = function() {
        this.frozen = document.createElement("div");
        this.frozen.setAttribute("class", "frozen connectedSortable ui-sortable");
        $(this.frozen).sortable({
            cancel: ".frozenEmptyList",
            connectWith: ".connectedSortable",
            update: function() {
                this.reOrderFrozen();
            }.bind(this),
            receive: function (event, ui) {
                var frozenEmptyList = this.frozen.querySelector(".frozenEmptyList");
                if(frozenEmptyList) {
                    this.frozen.removeChild(frozenEmptyList);
                }
                this.frozenFieldColumns.push(ui.item[0]?.fieldColumn);
                this.reOrderFrozen();
            }.bind(this),
            remove: function (event, ui) {
                this.removeFieldColumn(ui.item[0]?.fieldColumn, this.frozenFieldColumns);
                verifyFrozenEmpty();
                this.reOrderFrozen();
            }.bind(this)
        });
        return this.frozen;
    }.bind(this);

    var createNotFrozenDeselected = function() {
        this.notFrozenDeselected = document.createElement("div");
        this.notFrozenDeselected.setAttribute("class", "notFrozenDeselected connectedSortable ui-sortable");
        $(this.notFrozenDeselected).sortable({
            connectWith: ".connectedSortable",
            update: function(event, ui) {
                if(ui.item.parent()[0] === this.notFrozenDeselected) {
                    this.reOrderNotFrozenDeselected();
                }
            }.bind(this),
            remove: function (event, ui) {
                this.removeFieldColumn(ui.item[0]?.fieldColumn, this.notFrozenDeselectedFieldColumns);
            }.bind(this),
            receive: function (event, ui) {
                const fieldColumn = ui.item[0]?.fieldColumn;

                fieldColumn.unCheck();
                this.notFrozenDeselectedFieldColumns.push(fieldColumn);
            }.bind(this)
        });
        return this.notFrozenDeselected;
    }.bind(this);

    var filterFieldColumn = function() {
        const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        const inputText = normalize(this.filterInput.value.trim());
        const list = Array.prototype.slice.call(this.popUp.querySelectorAll("li"));

        list.forEach((element) => {
            const columnName = normalize(element.querySelector(".columnItem").innerHTML);
            element.style.display = columnName.match(inputText) ? "flex" : "none";
        });

    }.bind(this);

    this.createFilter = function() {
        this.filterArea = document.createElement("div");
        this.filterArea.setAttribute("class", "MonetUIAjaxFilter textField");

        this.headerTitle = document.createElement("h3");
        this.headerTitle.setAttribute("class", "headerTitle");
        this.headerTitle.innerText = Monet.I18n.getResourcesByKey("Monet.CustomizeColumns.label.title");

        this.filterInput = document.createElement("input");
        this.filterInput.setAttribute("type", "text");
        this.filterInput.setAttribute("placeholder", Monet.I18n.getResourcesByKey("Monet.CustomizeColumns.label.placeholder"));

        this.filterInput.addEventListener("keyup", filterFieldColumn);

        var iconFilter = document.createElement("div");
        iconFilter.setAttribute("class", "MonetUIAjaxIconFilter");

        this.filterArea.appendChild(this.headerTitle);
        this.filterArea.appendChild(this.filterInput);
        this.filterArea.appendChild(iconFilter);

        this.popUp.appendChild(this.filterArea);
    };

    this.createErrorDiv = function () {
        this.errorDiv = document.createElement("div");
        this.errorDiv.className = 'errorContent';

        const monetInlineAlerContainer = document.createElement("div");
        monetInlineAlerContainer.className = 'monetInlineAlerContainer';
        this.errorDiv.appendChild(monetInlineAlerContainer);

        this.popUp.appendChild(this.errorDiv);
    };

    this.showErrorMessage = function (resource) {
        if(this.errorTimeout) {
            clearTimeout(this.errorTimeout);
        }

        const monetMessage = new Monet.Form.Messages.InlineMessage();
        monetMessage.setParentNode(this.errorDiv);
        monetMessage.setInfoType("error");
        monetMessage.setMessage(Monet.I18n.getResourcesByKey(resource));
        monetMessage.triggerMessage();

        this.errorTimeout = setTimeout(() => {
            monetMessage.destroy();
        }, 4500);
    }

    var createCancelButton = function() {
        var cancel = document.createElement("input");
        cancel.setAttribute("name", "popupCustomizeColumnsCancel");
        cancel.setAttribute("type", "button");
        cancel.setAttribute("class", "btn");
        cancel.setAttribute("value", Monet.I18n.getResourcesByKey("Monet.CustomizeColumns.button.cancel"));
        cancel.addEventListener("click", this.togglePopUp.bind(this));
        return cancel;
    }.bind(this);

    var createSaveButton = function() {
        var save = document.createElement("input");
        save.setAttribute("name", "popupCustomizeColumnsSave");
        save.setAttribute("type", "button");
        save.setAttribute("class", "btn");
        save.setAttribute("value", Monet.I18n.getResourcesByKey("Monet.CustomizeColumns.button.save"));
        save.addEventListener("click", this.saveFieldList.bind(this));
        return save;
    }.bind(this);

    this.createPopUp = function () {

        this.popUp = document.createElement("div");
        this.popUp.setAttribute("class", "MonetUIGridActionsColumns right " + this.entity);
        this.popUp.setAttribute("style", "display: none;");

        var rigthList = document.createElement("div");
        rigthList.setAttribute("class", "MonetUIGridActionsColumnsList");
        rigthList.appendChild( createFrozen() );
        rigthList.appendChild( createNotFrozen() );
        rigthList.appendChild( createNotFrozenDeselected() );

        var popupCustomizeColumnsBtnGroup = document.createElement("div");
        popupCustomizeColumnsBtnGroup.setAttribute("class", "MonetUIGridActionsColumnsButtons standard-form-buttons");
        popupCustomizeColumnsBtnGroup.appendChild( createSaveButton() );
        popupCustomizeColumnsBtnGroup.appendChild( createCancelButton() );

        this.createFilter();
        this.createErrorDiv();

        this.popUp.appendChild(rigthList);
        this.popUp.appendChild(popupCustomizeColumnsBtnGroup);

        this.checkElementAndAppendChild(this.element, this.popUp);

    };

    this.hideOnEsc = (e) => {
        if (e.keyCode === 27) {
            this.hidePopup();
        }
    };

    this.hideOnOutsideClick = (e) => {
        if (!this.popUp.contains(e.target) && !e.target.classList.contains('MonetUIGridActionsCustomColumns')) {
            this.hidePopup();
        }
    };

    this.hideRemainingPopups = function(popup) {
        const elements = document.querySelectorAll('.MonetUIGridActionsColumns');

        elements.forEach(element => {
            if(element.className !== popup.className) {
                element.style.display = "none";
            }
        })
    }

    this.hidePopup = function() {
        this.popUp.style.display = "none";
        document.removeEventListener('keyup', this.hideOnEsc);
        document.removeEventListener('click', this.hideOnOutsideClick);
    }

    this.showPopup = function() {
        this.hideRemainingPopups(this.popUp);
        this.popUp.style.display = "flex";
        document.addEventListener('keyup', this.hideOnEsc);
        document.addEventListener('click', this.hideOnOutsideClick);

        Greenmile.Utils.fixGridActionsPopupsPosition({
            buttonSelector: `.MonetUIGridActionsButton.${this.entity}`,
            popupElementInstance: this.popUp
        });
    }

    this.togglePopUp = function() {
        if (this.popUp.style.display === "flex") {
            this.hidePopup();
        } else {
            this.showPopup();
        }
    };

    this.retrieveAvailableColumnsFromLayout = function () {

        var layout, collection, model, cleanLayout = [];

        layout = App.Forms[this.layoutNameSpace || this.screenName].layout[this.action];

        if (typeof(layout.models) === "undefined") {

            model = new App.Models.PageLayout();
            model.set(layout);

            collection = new App.Collections.PageLayout();
            collection.add(model);

        } else {
            collection = layout;
        }

        this.layoutFields = collection.getGridLayoutFieldList().filter(item => !this.hiddenFields.includes(item.field.name));


        for (var i = 0, j = this.layoutFields.length; i < j; i++) {
            if (this.layoutFields[i].field.name !== "id") {
                cleanLayout.push(this.layoutFields[i]);
            }
        }

        return cleanLayout;

    };

    this.gridIsNotMonet = function (screenName) {

        switch (screenName) {
            case "RouteSummaryRoutes":
            case "RouteSummaryStops":
            case "RouteSummaryOrders":
            case "RouteSummaryLineItems":
                return true;

            default:
                return false;
        }

    };

    this.getListToSave = function () {

        var model        = new App.Models.PageLayout();
        var collection   = new App.Collections.PageLayout();
        var layout, grid, objToSave;

        layout = App.Forms[this.layoutNameSpace || this.screenName].layout[this.action];
        grid = App.Forms[this.screenName].table;

        if (typeof(layout.models) === "undefined") {

            model = new App.Models.PageLayout();
            model.set(layout);

            collection = new App.Collections.PageLayout();
            collection.add(model);

        } else {
            collection = layout;
        }

        objToSave = {
            id: collection.getSearchGridLayoutId(),
            userId: Monet.Session.User.id,
            searchGridColumns: []
        };

        this.frozenFieldColumns.forEach(function(fieldColumn){
            var id = fieldColumn.getId();
            var size = grid.getColumnSizeByFieldId(id);
            if (!size) {
                size = fieldColumn.getLabel().length * 12;
            }
            if (size < 90) {
                size = 100;
            }
            var item = {
                columnOrder: fieldColumn.getOrder(),
                field: { id: id },
                isAscendent: true,
                isSorted: false,
                isFrozen: true,
                sizePixels: size
            };
            objToSave.searchGridColumns.push(item);
        });

        this.notFrozenFieldColumns.forEach(function(fieldColumn){
            var id = fieldColumn.getId();
            var size = grid.getColumnSizeByFieldId(id);
            if (!size) {
                size = fieldColumn.getLabel().length * 12;
            }
            if (size < 90) {
                size = 100;
            }
            var item = {
                columnOrder: fieldColumn.getOrder(),
                field: { id: id },
                isAscendent: true,
                isSorted: false,
                isFrozen: false,
                sizePixels: size
            };
            objToSave.searchGridColumns.push(item);
        });

        return objToSave;
    };

    /*
     * Usa a função getListToSave para coletar os dados e depois envia para o serviço que persiste
     * o layout do grid.
     *
     * @param {entity} string: Nome da entity utilizada na tela
     */

    this.saveFieldList = function () {

        var fieldsToSave = this.getListToSave();

        fieldsToSave.searchGridColumns.sort(function (a, b) {

            return parseInt(a.columnOrder) - parseInt(b.columnOrder);

        });

        if (fieldsToSave.searchGridColumns.length > 0) {

            fieldsToSave.searchGridColumns = fieldsToSave.searchGridColumns.filter(field => field.columnOrder);

            this.togglePopUp();

            if(!this.customSaveAction) {
                var requests = new Monet.Grid.ActionsModules.Requests(this.entity, this.layoutNameSpace, this.screenName, this.action);
                requests.saveGridLayout(fieldsToSave, this.callbacks);
            }else {
                this.customSaveAction(fieldsToSave);
            }

        } else {
            this.showErrorMessage("Monet.CustomizeGridLayout.error.cantSaveEmptyTableColumns");
        }

    };

    this.validations = function (fieldList) {

        var errorList = [],
            resourceKey = "Monet.CustomizeGridLayout.error.cantSaveEmptyTableColumns";

        if (fieldList.searchGridColumns.length === 0) {
            errorList.push( Monet.I18n.getResourcesByKey(resourceKey) );
        }

    };

    this.init = function () {

        if (typeof(this.screenName) === "undefined" || this.screenName === null) {
            this.screenName = Monet.Utils.GetTabName();
        }

        this.createBtn();
        this.createPopUp();

        if (this.callbacks && this.callbacks.afterInit) {
            this.callbacks.afterInit();
        }

    };

};
